import { Time24Input } from './Time24Input'

/**
 * DateTime24Input — date picker + Time24Input, combined into the same
 * "YYYY-MM-DDTHH:mm" value <input type="datetime-local"> uses.
 *
 * Native <input type="datetime-local"> has the same 12hr-picker-on-en-US
 * problem as <input type="time"> (see Time24Input for the full writeup).
 * The date portion of the native picker isn't AM/PM-ambiguous, so we keep
 * a native <input type="date"> for that half and only replace the time
 * half with the masked 24-hour text input.
 */
export function DateTime24Input({
  value,
  onChange,
  className,
}: {
  /** "YYYY-MM-DDTHH:mm" — same shape as <input type="datetime-local"> */
  value: string
  onChange: (val: string) => void
  className?: string
}) {
  const [datePart, timePart] = value ? value.split('T') : ['', '']

  const commit = (nextDate: string, nextTime: string) => {
    if (!nextDate && !nextTime) { onChange(''); return }
    onChange(`${nextDate}T${nextTime}`)
  }

  return (
    <div className="grid grid-cols-2 gap-2">
      <input
        type="date"
        value={datePart}
        onChange={e => commit(e.target.value, timePart)}
        className={className ?? 'w-full bg-gray-800 text-white rounded-lg px-3 py-2 text-sm border border-gray-700 focus:outline-none focus:ring-2 focus:ring-red-500'}
      />
      <Time24Input
        value={timePart}
        onChange={t => commit(datePart, t)}
        className={className ?? 'w-full bg-gray-800 text-white rounded-lg px-3 py-2 text-sm border border-gray-700 focus:outline-none focus:ring-2 focus:ring-red-500'}
      />
    </div>
  )
}
